export default {
  listProducts: [],
};
